import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import type { Theme } from '@mui/material/styles/createTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import { usePageView } from 'src/hooks/use-page-view';
import { Seo } from '../seo';
import logo from './error-404.png';

const ErrorPage = ({ errorInfo }: any) => {
  const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  usePageView();

  return (
    <>
      <Seo title="Error: Not Found" />
      <Box
        component="main"
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexGrow: 1,
          py: '80px',
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 6,
            }}
          >
            <img
              alt="Not found"
              src={logo}
              style={{
                height: 'auto',
                maxWidth: '80%',
                width: 300,
              }}
            />
          </Box>
          <Box>
            <Typography
              align="center"
              variant={mdUp ? 'h2' : 'h4'}
            >
              Something went wrong. Please contact system administrator.
            </Typography>
            {/* <Typography
              align="center"
              variant="h6"
              sx={{ mt: 1, mb: 1 }}
            >
              Error message: {errorInfo?.error?.message}
            </Typography> */}
          </Box>

          {/* <Box>
            <Typography
              align="center"
              color="text.secondary"
              sx={{ mt: 0.5 }}
            >
              Error Stack:
            </Typography>
            <Typography
              align="center"
              color="text.secondary"
              sx={{ mt: 0.5, height: 100, overflow: 'hidden' }}
              title={errorInfo?.error?.stack}
            >
              {errorInfo?.error?.stack}
            </Typography>
          </Box> */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 6,
            }}
          >
            <Button
              onClick={() => (window.location.href = '/dashboard')}
              variant="outlined"
            >
              Back to Home
            </Button>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default ErrorPage;
